import React from 'react';
import PropTypes from 'prop-types';
import { Col, Row } from 'antd';
import { connect } from 'react-redux';

import InfoCard from '../InfoCard';

import { composePlanCancellationDetails } from '../../utils/plan';

import { FIELDS } from './config';

const propTypes = {
  id: PropTypes.number,
  userEmail: PropTypes.string,
  UserId: PropTypes.number,
  cancelledAt: PropTypes.string,
  isDirectDebitCancelled: PropTypes.bool,
  isRefunded: PropTypes.bool,
  notes: PropTypes.string,
};
const defaultProps = {
  id: null,
  userEmail: null,
  UserId: null,
  cancelledAt: null,
  isDirectDebitCancelled: null,
  isRefunded: null,
  notes: null,
};

const PlanCancellationDetails = ({ id, ...props }) =>
  id ? (
    <Row gutter={16}>
      <Col span={10}>
        <InfoCard data={props} fields={FIELDS} />
      </Col>
    </Row>
  ) : null;

PlanCancellationDetails.propTypes = propTypes;
PlanCancellationDetails.defaultProps = defaultProps;

const mapStateToProps = ({ admin: { planCancellationDetails } }) =>
  composePlanCancellationDetails(planCancellationDetails);

export default connect(mapStateToProps)(PlanCancellationDetails);
